import { Link } from 'react-router-dom';
import { Car } from 'lucide-react';

export const ST = {
  bg: '#F5F6F8',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFC',
  surfaceSunken: '#F0F2F6',
  border: '#E5E7EB',
  borderStrong: '#D1D5DB',
  text: '#0B1220',
  textMuted: '#5B6478',
  textSubtle: '#8A93A6',
  primary: '#1E3A8A',
  primaryHover: '#1B3375',
  primarySoft: '#EEF1FA',
  accent: '#F59E0B',
  accentDeep: '#D97706',
  accentSoft: '#FEF3C7',
  success: '#0F8C5A',
  successSoft: '#E2F3EB',
  danger: '#DC2626',
  heroStart: '#0F1A3A',
  heroEnd: '#1E3A8A',
  font: '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, sans-serif',
};

function SimpleNav() {
  return (
    <header
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '20px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            textDecoration: 'none',
            color: ST.text,
          }}
        >
          <span
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: `linear-gradient(135deg, ${ST.heroStart}, ${ST.heroEnd})`,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            <Car size={20} strokeWidth={2.4} />
          </span>
          <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: -0.2 }}>
            Marmo Car
          </span>
        </Link>
      </div>
    </header>
  );
}

function SimpleFooter() {
  return (
    <footer
      style={{
        marginTop: 80,
        borderTop: `1px solid ${ST.border}`,
        background: ST.surface,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '32px 24px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 16,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ color: ST.textMuted, fontSize: 13 }}>
          © {new Date().getFullYear()} Marmo Car &middot;{' '}
          <a
            href="mailto:support@marmocar.pl"
            style={{ color: ST.primary, textDecoration: 'none' }}
          >
            support@marmocar.pl
          </a>
        </div>
        <div style={{ display: 'flex', gap: 18 }}>
          <Link
            to="/polityka-prywatnosci"
            style={{ color: ST.textMuted, textDecoration: 'none', fontSize: 13, fontWeight: 500 }}
          >
            Polityka prywatności
          </Link>
          <Link
            to="/regulamin"
            style={{ color: ST.textMuted, textDecoration: 'none', fontSize: 13, fontWeight: 500 }}
          >
            Regulamin
          </Link>
        </div>
      </div>
    </footer>
  );
}

export function SimpleLayout({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: ST.bg,
        color: ST.text,
        fontFamily: ST.font,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SimpleNav />
      <main style={{ flex: 1 }}>{children}</main>
      <SimpleFooter />
    </div>
  );
}
